// extracted by mini-css-extract-plugin
export default {"nestedNavItem":"style__nestedNavItem___Qks8H","labelWrapper":"style__labelWrapper___j3YrP"};